import { render } from "./SingleDetailsReshedule.vue?vue&type=template&id=380f406e&scoped=true"
import script from "./SingleDetailsReshedule.vue?vue&type=script&lang=js"
export * from "./SingleDetailsReshedule.vue?vue&type=script&lang=js"

import "./SingleDetailsReshedule.vue?vue&type=style&index=0&id=380f406e&scoped=true&lang=css"
import "./SingleDetailsReshedule.vue?vue&type=style&index=1&id=380f406e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380f406e"]])

export default __exports__